<template>
    <main>
        <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
                <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">RIESGO CARDIOVASCULAR</a>
            </li>
            <li class="nav-item" role="presentation">
                <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false"></a>
            </li>
            <li class="nav-item" role="presentation">
                <a class="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="contact" aria-selected="false"></a>
            </li>
        </ul>
        <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
             <indexRiesgoCardiovascular ref="indexRiesgoCardiovascular" :idHistoria="idHistoria" :finalizada="finalizada" :idUsuario="idUsuario"></indexRiesgoCardiovascular>
            
        </div>
        <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
            
        </div>
        <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
            
        </div>
        </div>
    
    </main>
    
</template>
<script>
import indexRiesgoCardiovascular from "../base/baseRiesgoCardiovascular/indexRiesgoCardiovascular";
import {required} from "vuelidate/lib/validators";

export default {
    props: ['idHistoria','finalizada','idUsuario'],
    components:{indexRiesgoCardiovascular},
    data(){
        return {
            riesgo : '',
        }
    },
    validations(){
        return {
            riesgo : {required},
        }
    },
   methods: {
        async save(){

            this.$refs.indexRiesgoCardiovascular.validate();
           
            if (!this.$refs.indexRiesgoCardiovascular.$v.$invalid) this.riesgo = 'S';
            //if (!this.$refs.complicacionesIdentificadas.$v.$invalid) this.complicaciones = 'S';
            //if (!this.$refs.examenPies.$v.$invalid) this.examenPies = 'S';
            
            this.$v.$touch();

            if(this.$v.$invalid) return;

            await this.$refs.indexRiesgoCardiovascular.retornar();
           //this.$nextTick(async () =>  { await this.$refs.complicacionesIdentificadas.save();});
           // this.$nextTick(async ()=>{ await this.$refs.examenPies.save();});
            
        }
    }
}
</script>

